import { Component, Input, HostBinding } from '@angular/core';

import { PublicCardApplicationRouteManager } from '@app/services/public-card-application-route-manager';

import { PARTNERS_LIST } from '@app/admin/fleet-card/shared/utils';

export enum LOGO_TYPES {
  FULL = 'full',
  COMPACT = 'compact',
  PARTNER = 'partner',
}

@Component({
  selector: 'logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  @Input() public class: string;
  @HostBinding('class.light-theme') @Input() public isLightTheme: boolean;
  @Input() public type: LOGO_TYPES = LOGO_TYPES.FULL;
  @Input() public partner: PARTNERS_LIST;

  public readonly logoTypes: typeof LOGO_TYPES = LOGO_TYPES;
  public readonly partnersList: typeof PARTNERS_LIST = PARTNERS_LIST;
  public readonly isPublicCardApplication: boolean;

  constructor (
    private publicCardApplicationRouteManager: PublicCardApplicationRouteManager,
  ) {
    this.isPublicCardApplication = this.publicCardApplicationRouteManager.isPublicCardApplication();
  }
}
